import { Field } from "rc-field-form";
import { useTranslation } from "react-i18next";
import { Label } from "reactstrap";
import Text from "../../../../../../../components/Inputs/Text";
import { firstToUpper } from "../../../../../../../utils/helpers/string";

function Item({ name, disabled, tier }) {
    const { t } = useTranslation();

    return (
        <div key={name} className="d-flex gap-2 align-items-center mb-2">
            <div className="w-100">
                <Label>{t("name")}</Label>
                <Text disabled={true} value={tier.name} />
            </div>

            <div className="w-100">
                <Label>{t("start")}</Label>
                <Text disabled={true} value={tier.start || ""} />
            </div>

            <div className="w-100">
                <Label>{t("end")}</Label>
                <Text disabled={true} value={tier.end || ""} />
            </div>

            <div className="w-100">
                <Label>{t("earned")}</Label>
                <Field
                    name={["intervals", name, "earned"]}
                    rules={[
                        {
                            required: true,
                            message: t("required-earned")
                        },
                        {
                            validator: (_, value) => {
                                if (value && Number(value) < 0) {
                                    return Promise.reject(
                                        new Error(t("readableField-bigger-than-zero", { readableField: t("earned") }))
                                    );
                                }
                                return Promise.resolve();
                            }
                        }
                    ]}
                >
                    <Text type="number" disabled={disabled} step="0.1" />
                </Field>
            </div>

            <div className="w-100">
                <Label>{firstToUpper(t("worked"))}</Label>
                <Field
                    name={["intervals", name, "worked"]}
                    rules={[
                        {
                            required: true,
                            message: t("required-worked")
                        },
                        {
                            validator: (_, value) => {
                                if (value && Number(value) < 0) {
                                    return Promise.reject(
                                        new Error(t("readableField-bigger-than-zero", { readableField: t("worked") }))
                                    );
                                }
                                return Promise.resolve();
                            }
                        }
                    ]}
                >
                    <Text type="number" disabled={disabled} step="0.1" />
                </Field>
            </div>

            <div className="w-100">
                <Label>{t("maximum")}</Label>
                <Field
                    name={["intervals", name, "max"]}
                    rules={[
                        {
                            required: true,
                            message: t("required-max")
                        },
                        ({ getFieldValue }) => ({
                            validator: (_, value) => {
                                const earned = getFieldValue(["intervals", name, "earned"]);
                               
                                if (value) {
                                    if (Number(value) < 0) {
                                        return Promise.reject(
                                            new Error(t("readableField-bigger-than-zero", { readableField: t("maximum") }))
                                        );
                                    } else if (earned && Number(earned) >= Number(value)) {
                                        return Promise.reject(
                                            new Error(t("max-bigger-than-earned"))
                                        );
                                    } else {
                                        return Promise.resolve();
                                    }

                                }
                                return Promise.resolve();
                            }
                        })
                    ]}
                >
                    <Text type="number" disabled={disabled} step="0.1" />
                </Field>
            </div>
        </div>
    );
}

export default Item;
